// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tabs_tabs__LbP0S","navLink":"Tabs_navLink__g8tu3"};